import { PlanDetailsItem } from "@swiggy-private/cart-types";

/* eslint-disable @typescript-eslint/naming-convention */
export interface OneBenefit {
    title: string;
    sub_title: string;
    show_shimmer?: boolean;
    color?: string;
    applyCustomClass?: boolean;
}

/**
 * This is introduced to send an identifier to the backend to track the source of the nudge.
 */
export enum FlowType {
    M2C = "M2C",
    LINE_ITEM = "LINE_ITEM",
    EXPRESS_HALF_CARD = "EXPRESS_HALF_CARD",
    FREEDEL_HALF_CARD = "FREEDEL_HALF_CARD",
    COMPARISON = "COMPARISON",
}

export enum NudgeType {
    REGULAR = "NUDGE_TYPE_REGULAR",
    TRIAL = "NUDGE_TYPE_TRIAL",
    ONE_TAP = "NUDGE_TYPE_ONE_TAP",
}

export interface RemovePlanTitle {
    text: string;
    attribute_values: {
        unicode: string;
    };
}

export interface RemovePlanContent {
    title: string;
    sub_title: string;
    attribute_values: {
        svg_value: string;
    };
}
export interface RemovePlanMessage {
    title: RemovePlanTitle;
    content: RemovePlanContent[];
}

export interface FooterComms {
    title: string;
    cta: {
        text: string;
        type: string;
        link: string;
    };
}

export enum ProgramTypes {
    ONE = "PLAN_PROGRAM_ONE",
    OFFER_BUNDLE = "PLAN_PROGRAM_OFFER_BUNDLE",
    INVALID = "PLAN_PROGRAM_INVALID",
    SUPER = "SUPER",
}

export enum ProgramSubTypes {
    PLUS = "PLAN_TYPE_PLUS",
    LITE = "PLAN_TYPE_LITE",
    INVALID = "PLAN_TYPE_INVALID",
    FREE_DEL = "PLAN_TYPE_FOOD_FREEDEL",
    BLACK = "PLAN_TYPE_BLACK",
}

export enum DeliveryTagInfoVisibilityLevel {
    INVALID = "VISIBILITY_LEVEL_INVALID",
    LOW = "VISIBILITY_LEVEL_LOW",
    MEDIUM = "VISIBILITY_LEVEL_MEDIUM",
    HIGH = "VISIBILITY_LEVEL_HIGH",
}

export interface GradientColorType {
    isHigh: boolean;
    isLow: boolean;
    isMedium: boolean;
}

export interface DeliveryTagInfoUIData {
    count: string;
    countText: string;
    countSubText: string;
    colorType: GradientColorType;
}

export interface DeliveryTagInfoUIDataMweb {
    pillText: string;
    subText: string;
    pillBgColor: string;
    textColor: string;
}

export interface DeliveryTagInfo {
    text: string;
    sub_text: string;
    visibility_level: DeliveryTagInfoVisibilityLevel;
}

export interface TooltipContext {
    benefits_change_type: string;
    tooltip_text: string;
}

export interface AddSuperProps {
    title: string;
    subtitle: string;
    cta: string;
    plan: PlanDetailsItem;
    toolTipContext?: TooltipContext;
}
